<template>
    <div class="container">
        <!-- <h1 class="mt-5">欢迎来到我们的化妆品网页</h1> -->

        <div class="top">
            <div class="top-content">

                <div class="img-content" v-if="isMobile">
                    <carousel :autoplay="true" :autoplay-speed="3000" :loop="true" height="200px" :per-page="1">
                        <slide v-for="(image, index) in imagesLunbo" :key="index">
                            <img :src="require('@/assets/images/mobile/' + image.filename)" :alt="image.alt"
                                class="img-fluid">
                        </slide>
                    </carousel>
                </div>
                <div class="img-content" v-else>
                    <img :src="require('@/assets/images/main.jpg')" alt="">
                </div>
                <!-- 轮播图 -->



                <!-- 视频播放器 -->
                <!-- <div style="width: 100%;">
                    <video class="video-container" autoplay loop muted playsinline>
                        <source src="../assets/images/1.mp4" type="video/mp4">
                    </video>
                </div> -->

                <!-- 右侧文字内容 -->
                <!-- <div class="top-right">
                    <h1>COSMETICS<br> FOREIGN<br> BEAUTY</h1>
                    <p>Cosmetics foreign is a professional turnkey provider in the fields of Cosmetics and Personal Care
                        products, specialty in skincare, body care, hair care, fine fragrance, makeup and value-added
                        pack out etc.</p>
                </div> -->
            </div>
            <!-- <div class="lunbo" style="margin-top: 40px;">
                <p style="font-size: 44px;">重要公告</p>
                <carousel class="carousel-container" :autoplay="true" :autoplay-speed="1000" :loop="true"
                    :pagination-enabled="false" height="300px" :per-page="1">
                    <slide v-for="(image, index) in imagesLunbo" :key="index">
                        <img :src="require('@/assets/images/' + image.filename)" :alt="image.alt"
                            class="img-fluid desktop-image2" :style="{ maxHeight: image.maxHeight }">
                    </slide>
                </carousel>
            </div> -->

        </div>

        <!-- 图片和文字描述 -->
        <div class="row" v-if="isMobile">
            <div class="col-md-6 offset-md-3">
                <div v-for="(image, index) in images2" :key="index" class="mb-4 text-center">
                    <p class="desktop-image-description">{{ image.description }}</p>
                    <img :src="require('../assets/images/mobile/' + image.filename)" :alt="image.alt"
                        class="img-fluid desktop-image" :style="{ maxHeight: image.maxHeight }"
                        @click="goToBuyPage(image.productId)">
                </div>
            </div>
        </div>
        <!-- 图片和文字描述 -->
        <div class="row" v-else>
            <div class="col-md-6 offset-md-3">
                <div v-for="(image, index) in images" :key="index" class="mb-4 text-center">
                    <p class="desktop-image-description">{{ image.description }}</p>
                    <img :src="require('../assets/images/main/' + image.filename)" :alt="image.alt"
                        class="img-fluid desktop-image" :style="{ maxHeight: image.maxHeight }"
                        @click="goToBuyPage(image.productId)">
                </div>
            </div>
        </div>

        <!-- 必买清单 -->
        <div class="row ">
            <div class="col-md-6 offset-md-3 ">
                <h2 class="text-center mb-4">必买清单</h2>
                <ul class="list-unstyled inventory">
                    <li v-for="(item, index) in mustBuyList" :key="index" class="mb-3">
                        <img :src="require('../assets/images/bimai/' + item.filename)" :alt="item.alt"
                            class="img-fluid rounded"
                            :style="{ width: item.width, height: item.height, maxHeight: item.maxHeight }"
                            @click="goToBuyPage(item.productId)">
                    </li>
                </ul>
            </div>
        </div>


        <!-- 弹框 -->
        <el-dialog :visible.sync="showModal" :width="dialogWidth" @close="closeModal">
            <el-skeleton :loading="loading" animated>
                <template slot="template">
                    <el-skeleton-item variant="image" class="skeleton"></el-skeleton-item>
                </template>
                <template>
                    <img :src="getCurrentImageSrc" alt="每日公告" class="announcement-image">
                </template>
            </el-skeleton>
            <!-- <span slot="footer" class="dialog-footer"> -->
            <!-- <el-button @click="closeModal">关闭</el-button> -->
            <!-- <el-button type="primary" @click="nextAnnouncement">下一条</el-button> -->
            <!-- </span> -->
        </el-dialog>
        <!-- 其他内容 -->
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'HomePage', // 组件名称
    components: {
        Carousel,
        Slide
    },
    data () {
        return {
            dialogVisible: true,
            dialogWidth: '35%', // 默认宽度
            isMobile: false,
            // 主页显示图片
            images: [
                {
                    filename: 'cn.png',
                    alt: 'Image 1',
                    description: '柔雾泥感 丝滑显色',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2001' // 产品ID
                },
                {
                    filename: 'sf.png',
                    alt: 'Image 2',
                    description: '柔雾定妆 清爽控油',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2006' // 产品ID
                },
                {
                    filename: 'yyp.png',
                    alt: 'Image 3',
                    description: '星眸闪耀 灵动玩妆',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2004' // 产品ID
                },
                {
                    filename: 'jmg.png',
                    alt: 'Image 4',
                    description: '持久卷翘 细睫出众',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2007' // 产品ID
                },
            ],
            images2: [
                {
                    filename: 'jiaobi002.jpg',
                    alt: 'Image 1',
                    description: '眼妆系列',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1003' // 产品ID
                },
                {
                    filename: 'chunni001.jpg',
                    alt: 'Image 2',
                    description: '唇妆系列',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2001' // 产品ID
                },
                {
                    filename: 'sanfen003.jpg',
                    alt: 'Image 3',
                    description: '底妆系列',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2006' // 产品ID
                },
                {
                    filename: 'ximiannai004.jpg',
                    alt: 'Image 4',
                    description: '清洁系列',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2021' // 产品ID
                },
            ],
            imagesLunbo: [
                {
                    filename: 'chunni02.jpg',
                    alt: 'Image 1',
                    description: '轻盈似雪 自然定格',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2001' // 产品ID
                },
                {
                    filename: 'sanfen03.jpg',
                    alt: 'Image 1',
                    description: '轻盈似雪 自然定格',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2006' // 产品ID
                },
                {
                    filename: 'yanyingpan01.jpg',
                    alt: 'Image 1',
                    description: '轻盈似雪 自然定格',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '2009' // 产品ID
                },
            ],

            mustBuyList: [ // 必买清单数据
                { filename: 'cn.png', alt: 'Image 1', width: '90%', maxHeight: '200px', productId: '2001' },
                { filename: 'jmg.png', alt: 'Image 2', width: '90%', maxHeight: '200px', productId: '2007' },
                { filename: 'sf.png', alt: 'Image 3', width: '90%', maxHeight: '200px', productId: '2006' },
                { filename: 'yyp.png', alt: 'Image 4', width: '90%', maxHeight: '200px', productId: '2004' },
                // { filename: 'buyList5.jpg', alt: 'Image 5', width: '90%', maxHeight: '200px', productId: '2005' }
            ],
            showModal: false,
            currentAnnouncementIndex: 0,
            loading: true,
            announcements: [
                // { filename: 'announcement1.jpg' },
                { filename: 'gonggao86.png' },
                // { filename: 'announcement2.jpg' },
                // { filename: 'announcement3.jpg' }
            ],
        };
    },
    computed: {
        getCurrentImageSrc () {
            return require(`@/assets/images/${this.announcements[this.currentAnnouncementIndex].filename}`);
        }
    },
    methods: {

        updateDialogWidth () {
            if (window.innerWidth >= 996) {
                this.dialogWidth = '35%'; // 桌面端宽度
                this.isMobile = false
            } else {
                this.dialogWidth = '70%'; // 移动端宽度
                this.isMobile = true
            }
        },
        goToBuyPage (productId) {
            this.$router.push({ name: 'BuyPage', params: { productId: productId } });
        },
        nextAnnouncement () {
            this.loading = false;
            this.currentAnnouncementIndex = (this.currentAnnouncementIndex + 1) % this.announcements.length;
        },
        closeModal () {
            this.showModal = false;
        },
        openModal () {
            this.showModal = true;
            this.loading = true; // 打开弹框时，先显示骨架屏
        },
        handleImageLoad () {
            this.loading = false;
        },
        handleImageError () {
            this.loading = false;
            console.error('图片加载失败');
        }
    },
    mounted () {
        this.updateDialogWidth();
        this.openModal();
        setTimeout(() => {
            this.loading = false;
        }, 1000);
    }
}
</script>

<style scoped>
.announcement-image {

    width: 100%;
    /* max-height: 400px; */
    object-fit: contain;
}



.img-content img {
    width: 50%;
}

/* 添加你的自定义样式或者覆盖Bootstrap的样式 */
/* 修改标题的样式 */
h1 {
    color: #333;
    font-size: 2.5rem;
}

.container {
    max-width: 100%;
    margin: 0;
    /* padding-left: 0; */
    padding: 0;
    box-sizing: border-box;
    /* text-align: center; */
}

.row {
    width: 100%;
    margin: 0;
}

.top {
    text-align: center;
}

.top-content {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.top-right {
    padding: 20px;
}

.rounded {
    border-radius: 20px !important;
    /* 设置圆角半径为10像素 */
}

/* 桌面端 */
@media only screen and (min-width: 996px) {
    .img-content {
        text-align: center;
    }

    .top-right h1 {
        font-weight: normal;
        font-size: 60px;
        color: #2c2c2c;
        line-height: 61px;
    }

    .skeleton {
        width: 100%;
        height: 400px;
    }

    .top {
        display: flex;
        flex-direction: column;
        /* margin-top: 60px; */
    }

    .inventory {
        display: flex;
        justify-content: center;
    }

    .video-container {
        width: 100%;
        height: auto;
    }
}

/* 移动端 */
@media only screen and (max-width: 996px) {
    ::v-deep .el-dialog__body {
        padding: 0 !important;
    }

    .desktop-image-description {
        font-size: 1.2rem;
        font-weight: 600;
        letter-spacing: 0.1rem;
        /* font-family:'黑体'; */
    }

    .img-content {
        text-align: center;
        margin-top: 3rem;
    }

    .top-right h1 {
        font-weight: normal;
        font-size: 30px;
        color: #2c2c2c;
        line-height: 35px;
    }

    .skeleton {
        width: 100%;
        height: 10rem;
    }

    .top {
        display: flex;
        flex-direction: column;
        /* margin-top: 30px; */
    }

    .inventory {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
    }

    li {
        text-align: center;
    }

    .video-container {
        height: 50vh;
    }
}



.top-right p {
    color: #2c2c2c;
    font-size: 16px;
    line-height: 30px;
}

@media (max-width: 768px) {
    .top-content {
        flex-direction: column;
    }
}

.carousel-container {
    margin-top: 40px;
    /* 距离顶部的距离 */
}

.navbar {
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 1000;
    /* 确保导航栏在其他内容上方 */
}

/* 修改主要内容的样式 */
p {
    font-size: 1.2rem;
}

/* 移动端侧边栏导航 */
.sidebar {
    position: fixed;
    top: 56px;
    /* 与导航栏的高度相等，具体高度可根据需要调整 */
    bottom: 0;
    left: -250px;
    /* 初始时隐藏侧边栏 */
    width: 250px;
    padding-top: 1rem;
    background-color: #fff;
    transition: left 0.3s ease;
}


.sidebar.show {
    left: 0;
}

/* 桌面端导航 */
.navbar-nav {
    margin-left: auto;
}

/* 桌面端图片 */
.desktop-image {
    width: 1000px;
    /* 设置图片宽度为屏幕宽度的80% */
}

.desktop-image2 {
    /* width: 2000px; */
    /* 设置图片宽度为屏幕宽度的80% */
}

.offset-md-3 {
    margin-left: 0%;
}

.col-md-6 {
    width: 100%;
}


@media (min-width: 768px) {
    p.desktop-image-description {
        font-size: 44px;
    }
}

/* 新添加的样式 */
/* 导航栏项悬浮效果 */
.nav-item:hover .dropdown-content {
    display: block;
}

/* 悬浮框样式 */
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 700px;
}

.suspend {
    display: flex;
}


/* 图片样式 */
.brand-image {
    width: 200px;
    height: auto;
    margin-right: 20px;
}

/* 取消a标签的默认样式 */
a {
    color: inherit;
    /* 继承父元素的文本颜色 */
    text-decoration: none;
    /* 取消下划线 */
}

/* 悬停时设置颜色 */
a:hover {
    /* color: #ff0000; 设置悬停时的颜色 */
}

li {
    list-style-type: none;
}

.img-content {
    text-align: center;
}

.img-content img {
    width: 100%;
}</style>
